import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AdminPageComponent} from './pages/admin-page/admin-page.component';
import {TITLE} from '@twpub/core/constants';
import {AuthGuard} from '@twpub/shared/guards/auth.guard';
import {AdminHomeComponent} from './components/admin-home/admin-home.component';
import {ConfigurationsPanelComponent} from './components/configurations-panel/configurations-panel.component';
import {SettingsPanelComponent} from './components/settings-panel/settings-panel.component';
import {DictionariesPanelComponent} from './components/dictionaries-panel/dictionaries-panel.component';
import {DictionaryDetailsComponent} from './components/dictionary-details/dictionary-details.component';
import {SearchableFieldsPanelComponent} from './components/searchable-fields-panel/searchable-fields-panel.component';
import {SuggestionsPanelComponent} from './components/suggestions-panel/suggestions-panel.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    data: {requiredGroups: ['admin']},
    component: AdminPageComponent,
    title: `${TITLE} - Administration`,
    children: [
      {path: '', redirectTo: 'home', pathMatch: 'full'},
      {path: 'home', component: AdminHomeComponent},
      {path: 'layouts', component: ConfigurationsPanelComponent, title: `${TITLE} - Page Layouts`},
      {path: 'fields', component: SearchableFieldsPanelComponent, title: `${TITLE} - Searchable Fields`},
      {path: 'settings', component: SettingsPanelComponent, title: `${TITLE} - Settings`},
      {path: 'dictionaries', component: DictionariesPanelComponent, title: `${TITLE} - Dictionaries`},
      {path: 'dictionaries/:id', component: DictionaryDetailsComponent, title: `${TITLE} - Dictionary Details`},
      {path: 'suggestions', component: SuggestionsPanelComponent, title: `${TITLE} - Suggestions`}
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule {
}
